import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

function EventCard({
  event, selectedEvents, handleSelectEvent, onRemove,
}) {
  const navigate = useNavigate();

  // Normalize data access for potential casing issues (camelCase vs snake_case)
  const eventId = event.id || event.event_id;
  const eventName = event.name || event.event_name;
  const startAt = event.startAt || event.start_at;
  const endAt = event.endAt || event.end_at;
  const participants = event.eventParticipants || event.event_participants || [];
  const eventData = event.eventData || event.event_data || [];
  const submissions = eventData[0]?.leaderboardSubmissions
    || eventData[0]?.leaderboard_submissions
    || 0;

  return (
    <div className="bg-gray-100 p-4 rounded-md shadow">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold text-center">{eventName}</h2>
        <input
          type="checkbox"
          checked={selectedEvents.includes(eventId)}
          onChange={() => handleSelectEvent(eventId)}
        />
      </div>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="flex flex-col flex-col md:flex-col">
          <p className="text-sm text-gray-500 flex-col md:flex-col">Start Date: {startAt ? new Date(startAt).toLocaleDateString() : 'N/A'}</p>
          <p className="text-sm text-gray-500 flex-col md:flex-col">End Date: {endAt ? new Date(endAt).toLocaleDateString() : 'N/A'}</p>
        </div>
        <div className="flex flex-col md:flex-row lg:flex-col text-left md:text-right">
          <p className="text-sm text-gray-500 flex-col md:flex-row">Participants: {participants.length}</p>
          <p className="text-sm text-gray-500 flex-col md:flex-row">Leaderboard Submissions: {submissions}</p>
        </div>
      </div>
      <div className="flex flex-row justify-between mt-4">
        <div className="flex space-x-2">
          <button
            type="button"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
            onClick={() => navigate(`/my-events/manage/${eventId}`)}
            title="Manage Event"
          >
            Manage
          </button>
          {submissions > 0 && (
            <button
              type="button"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded"
              onClick={() => navigate(`/my-events/view-leaderboard/${eventId}`)}
              title="View Leaderboards"
            >
              View Leaderboards
            </button>
          )}
        </div>
        {onRemove && (
          <button
            type="button"
            className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded"
            onClick={() => onRemove(eventId)}
            title="Remove from Series"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        )}
      </div>
    </div>
  );
}

EventCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    event_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    event_name: PropTypes.string,
    startAt: PropTypes.string,
    start_at: PropTypes.string,
    endAt: PropTypes.string,
    end_at: PropTypes.string,
    eventParticipants: PropTypes.arrayOf(PropTypes.shape({})),
    event_participants: PropTypes.arrayOf(PropTypes.shape({})),
    eventData: PropTypes.arrayOf(PropTypes.shape({
      leaderboardSubmissions: PropTypes.number,
      leaderboard_submissions: PropTypes.number,
    })),
    event_data: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  selectedEvents: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  handleSelectEvent: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
};

EventCard.defaultProps = {
  onRemove: null,
};

export default EventCard;
